import PropTypes from 'prop-types';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Link as RouterLink, useLocation, useParams } from 'react-router-dom';
import liff from '@line/liff';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import IconButton from '@mui/material/IconButton';

import { DateTime } from 'luxon';
import md5 from 'md5';
import { Box, Link } from '@mui/material';
import { FacebookCircularProgress } from '../components/progress';
import Iconify from '../components/iconify/Iconify';
import UserService from '../services/user.service';

import { isLocalhost } from '../App';
import ViewUser from '../sections/profile/ViewUser';
import EditUser from '../sections/profile/EditUser';

const liffId = '2004746697-O6JRybro' // process.env.REACT_APP_LIFF_ID

function logOut() {
    liff.logout()
    // setSignedIn(false)
    window.location.reload()
}

function logIn() {
liff.login({ redirectUri: window.location.href })
}

async function getLineProfile() {
    const profile = await liff.getProfile()
    // document.getElementById("pictureUrl").style.display = "block"
    // document.getElementById("pictureUrl").src = profile.pictureUrl
    return profile
}

Profile.propTypes = {
  toEdit: PropTypes.bool,
  userprofile: PropTypes.object
};

export default function Profile({ toEdit, userprofile={} }) {

    const { pathname } = useLocation();
    const params = useParams()
    const userInitiated = params.mode && params.mode === 'userinitiated';

    // window.alert(`userInitiated ${userInitiated}`)
    const [profile, setProfile] = useState(userprofile);
    const [liffInfo, setLiffInfo] = useState({})
    const [user, setUser] = useState(profile);

    const [editing, setEditing] = useState(toEdit || false);

    // const [scanning, setScanning] = useState(false);
    // const [log, setLog] = useState("LOG appears here");

    useEffect(() => {


        // let user
        if (isLocalhost) {

            const profile = {
              userId: 'abc',
              displayName: 'Chaloemphol',
              statusMessage: 'ev’ry moment new',
              pictureUrl: '/assets/images/avatars/avatar_2.jpg',
              tocAccepted: true,
              role: 'user'
            }
            setProfile(profile)
        // })
          return undefined
        }

        (async () => {

        //   if (isLocalhost) return
        await liff.init({ liffId, withLoginOnExternalBrowser: pathname.includes('edituserprofile')})

        if (!liff.isInClient() && !liff.isLoggedIn()) {
          liff.login()
        }
        await getLineProfile()
          .then( data => {

          //   let profile = data
          //   user = await getLineProfile(data.userId)
          //   if (user) profile = { ...user , ...profile }
              // window.alert(JSON.stringify(data))
            setProfile(data)

          })



          // await liff.init({ liffId, withLoginOnExternalBrowser: false})

          // if (liff.isInClient()) {
          //   // window.alert('ok')
          //   await getLineProfile()
          //   .then( data => {

          //   //   let profile = data
          //   //   user = await getLineProfile(data.userId)
          //   //   if (user) profile = { ...user , ...profile }
          //       // window.alert(JSON.stringify(data))
          //     setProfile(data)

          //   })

          // }
        })()

        return undefined
      }, []);


      
      // useEffect(() => {
      //   (async () => {

      //     await liff.getFriendship()
      //       .then(r => setLiffInfo(i => ({ ...i, 
      //         'isInClient': liff.isInClient(),
      //         'getVersion' : liff.getVersion(),
      //         'getLineVersion' : liff.getLineVersion(),
      //         'friendFlag': r.friendFlag })))          
      //   })()  
      
      // }, [liff])


const info = useMemo(() => {
    // if (!isLocalhost && (!profile || !profile.displayName)) return (<Box sx={{ textAlign: 'center', width: '100%', pt: 20}} ><FacebookCircularProgress /></Box>)

     if (editing && profile && profile.userId) return (<EditUser profile={{...user, ...profile}} setProfile={setProfile} setEditing={setEditing} />)
     if (profile && profile.userId) return (<ViewUser liff={liff} userId={profile.userId} setUser={setUser} setEditing={setEditing} toEdit userInitiated={userInitiated} />)
     return (<div>เข้าสู่ระบบด้วยไลน์ ...
      {/* <Typography variant='caption'>{JSON.stringify(liffInfo)}</Typography>
      หากโหลดนานให้กด <Link to="https://flexitarmstrong.web.app/dashboard/edituserprofile/?openExternalBrowser=1" component={RouterLink} sx={{ display: 'contents' }}>
      ลิงค์สำรอง
    </Link> */}
     </div>)
  },[profile, editing])

  return <>{info}</>

}